import { AppLauncher } from "@capacitor/app-launcher";

function downloadFile(url) {
  return AppLauncher.openUrl({ url });
}

export default downloadFile;
